import axios from 'axios'
import 'url-search-params-polyfill'
import { get } from 'lodash'

import generateUuid from '../utilities/api/generateUuid'
import { setMinuteCookie } from '../utilities/session/setCookie'
import getCookie from '../utilities/session/getCookie'
import fetchAccorProfileUser from './fetchAccorProfileUser'

export const FETCH_LOGIN_TOKEN_BEGIN   = 'FETCH_LOGIN_TOKEN_BEGIN'
export const FETCH_LOGIN_TOKEN_SUCCESS = 'FETCH_LOGIN_TOKEN_SUCCESS'
export const FETCH_LOGIN_TOKEN_FAILURE = 'FETCH_LOGIN_TOKEN_FAILURE'

export const FETCH_LOGIN_SESSIONS_BEGIN   = 'FETCH_LOGIN_SESSIONS_BEGIN'
export const FETCH_LOGIN_SESSIONS_SUCCESS = 'FETCH_LOGIN_SESSIONS_SUCCESS'
export const FETCH_LOGIN_SESSIONS_FAILURE = 'FETCH_LOGIN_SESSIONS_FAILURE'

export const fetchLoginTokenBegin = () => ({
	type: FETCH_LOGIN_TOKEN_BEGIN,
})

export const fetchLoginTokenSuccess = transactionToken => ({
	type: FETCH_LOGIN_TOKEN_SUCCESS,
	payload: transactionToken
})

export const fetchLoginTokenError = error => ({
	type: FETCH_LOGIN_TOKEN_FAILURE,
	payload: { error }
})

export const fetchLoginSessionsBegin = () => ({
	type: FETCH_LOGIN_SESSIONS_BEGIN,
})

export const fetchLoginSessionsSuccess = loginSessions => ({
	type: FETCH_LOGIN_SESSIONS_SUCCESS,
	payload: loginSessions
})

export const fetchLoginSessionsError = error => ({
	type: FETCH_LOGIN_SESSIONS_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchAccorLoginToken(accorAuthCode, refreshToken) {
	return (dispatch) => {
		const queryParams = new URLSearchParams()
		queryParams.append('code', accorAuthCode)

		if (refreshToken) {
			queryParams.append('refresh_token', refreshToken)
			queryParams.append('grant_type', 'refresh_token')
		} else {
			queryParams.append('redirect_uri', process.env.REACT_APP_CRM_AUTH_REDIRECT_URL)
			queryParams.append('grant_type', 'authorization_code')
		}

		const piSriToken = getCookie('accorPiSriToken')

		const headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Authorization': `Basic ${btoa(process.env.REACT_APP_CRM_API_APP_ID + ':' + process.env.REACT_APP_CRM_API_SECRET_KEY)}`,
		}

		const authenticationApi = `${process.env.REACT_APP_CRM_AUTH_PROVIDER_URL}/as/token.oauth2?${queryParams.toString()}`

		dispatch(fetchLoginTokenBegin())
		return axios.post(authenticationApi, {}, {
			headers: headers
		})
			.then((response) => {
				const authData = get(response, 'data', null)

				if (authData) {
					const accessToken = get(authData, 'access_token', null)

					setMinuteCookie('accorAuthToken', btoa(JSON.stringify(authData)), 15)

					if (
						piSriToken &&
						piSriToken !== ''
					) {
						dispatch(fetchLoginSessions(piSriToken))
					}

					if (accessToken) {
						dispatch(fetchAccorProfileUser(accessToken))
					}

					dispatch(fetchLoginTokenSuccess(authData))
				}
			})
			.catch(error => {
				dispatch(fetchLoginTokenError(error))
			})
	}
}

export function fetchLoginSessions(piSriToken) {
	return (dispatch) => {
		const headers = {
			'Content-Type': 'application/json',
			'Authorization': `Basic ${btoa(process.env.REACT_APP_CRM_API_APP_ID + ':' + process.env.REACT_APP_CRM_API_SECRET_KEY)}`,
			'X-XSRF-Header': generateUuid()
		}

		const authenticationApi = `${process.env.REACT_APP_CRM_AUTH_PROVIDER_URL}/pf-ws/rest/sessionMgmt/sessions/${piSriToken.toString()}`

		dispatch(fetchLoginSessionsBegin())
		return axios.get(authenticationApi, {
			headers: headers
		})
			.then((response) => {
				const sessionData = get(response, 'data', null)

				if (sessionData) {
					dispatch(fetchLoginSessionsSuccess(sessionData))
				}
			})
			.catch(error => {
				dispatch(fetchLoginSessionsError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchAccorLoginToken.js